
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as g0vHKkLpOpbELuMxbYZCc4FeBLaq6vmh1vzEK6Z7JSOwMeta } from "/codebuild/output/src1827453765/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexQPYRWlN_45fd9E4zes7Rhu3265QCGRzXkZrtpYf_45V7mRsMeta } from "/codebuild/output/src1827453765/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchJdByqFIcGk6HxXE6iKTSNeAApCKJ0tPdFW_6QIVs8fYMeta } from "/codebuild/output/src1827453765/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexloEKl3DxwOfGvNZQ4vzGLKXZaV_45nWTdVuzQN168K_sEMeta } from "/codebuild/output/src1827453765/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_933GyhKPRoryWgLxjtgdnTe87Abq32VCdIqNTHGCudH4IMeta } from "/codebuild/output/src1827453765/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as index9R95mwSKSTy3GPORYBTfAQ3qiLZRTzJ882Z5CdKNG_4Meta } from "/codebuild/output/src1827453765/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93wZmm9jpuBbrXxSUnpKpA6bbKgXuAXH005tSDIjMd8cgMeta } from "/codebuild/output/src1827453765/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexfO0NmeRz4zF9Gb30_450k4Az5Ny3I5gsqcVa63vZK7EPMMeta } from "/codebuild/output/src1827453765/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_933Z9mPiislfRBWqcSAIrQ3KPUpn0jNZ_skjoBdJp9mxYMeta } from "/codebuild/output/src1827453765/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexPcoA4egmM_45XjfWKhYjjSvN8tB9fNWYbRCcSGeCJhHbMMeta } from "/codebuild/output/src1827453765/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as index8okjQHiSFS8nDiiC1LRboAgEzEpqRImEonORn_ole9oMeta } from "/codebuild/output/src1827453765/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src1827453765/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src1827453765/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src1827453765/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src1827453765/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src1827453765/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: index9R95mwSKSTy3GPORYBTfAQ3qiLZRTzJ882Z5CdKNG_4Meta || {},
    component: () => import("/codebuild/output/src1827453765/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src1827453765/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexfO0NmeRz4zF9Gb30_450k4Az5Ny3I5gsqcVa63vZK7EPMMeta || {},
    component: () => import("/codebuild/output/src1827453765/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src1827453765/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexPcoA4egmM_45XjfWKhYjjSvN8tB9fNWYbRCcSGeCJhHbMMeta || {},
    component: () => import("/codebuild/output/src1827453765/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: index8okjQHiSFS8nDiiC1LRboAgEzEpqRImEonORn_ole9oMeta || {},
    component: () => import("/codebuild/output/src1827453765/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]